import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { UpdateGarantieProduit } from "../../core/model/garantie-produit/update-garantie-produit";
import { GarantieProduitDTO } from "../../core/model/garantie-produit/garantie-produit-dto";
import { GarantieProduitService } from "../../core/service/garantie-produit.service";

@Component({
  selector: "app-edit-garantie-produit",
  templateUrl: "./edit-garantie-produit.component.html",
  styleUrls: ["./edit-garantie-produit.component.scss"],
})
export class EditGarantieProduitComponent implements OnInit {
  erreur: String = "";
  @Input() produitId: number;

  @Input()
  set garantieProduit(value: GarantieProduitDTO) {
    if (value) {
      this._garantieProduit = { ...value };
      this.updateGarantieProduit = {
        garantieProduitId: value.id,
        code: value.code,
        label: value.label,
        produitId:
          (value.produit && value.produit.id) || this.produitId,
      };
      this.cdr.detectChanges();
    }
  }
  get garantieProduit(): GarantieProduitDTO {
    return this._garantieProduit;
  }

  private _garantieProduit: GarantieProduitDTO;
  updateGarantieProduit: UpdateGarantieProduit = new UpdateGarantieProduit();

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = false;

  constructor(
    private _garantieProduitService: GarantieProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    if (this.updateGarantieProduit && !this.updateGarantieProduit.produitId) {
      this.updateGarantieProduit.produitId = this.produitId;
    }
  }

  save(): void {
    if (!this.updateGarantieProduit.produitId) {
      this.updateGarantieProduit.produitId = this.produitId;
    }
    this.pressButton = true;
    this._garantieProduitService
      .update(this.updateGarantieProduit)
      .pipe(first())
      .subscribe(
        () => {
          const updated: GarantieProduitDTO = {
            ...this.garantieProduit,
            id: this.updateGarantieProduit.garantieProduitId,
            code: this.updateGarantieProduit.code,
            label: this.updateGarantieProduit.label,
          };
          this.pressButton = false;
          this.activeModal.close(updated);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
